import React from "react";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import Icon from "material-ui/Icon";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Title from "../../ui/title";
import Checkbox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { RadioGroup, Divider, Grid, Radio } from "material-ui";
import Content from "../../ui/content";
import { withStyles } from "material-ui/styles";
import Input, { InputLabel } from "material-ui/Input";
import styles from "./styles";
import SelectCable from "../common/selectCable";
import ConfirmDialog from "../../common/dialog/confirm";
import { validateFormData } from "../../../common/formtool";

import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { withRouter } from "react-router-dom";
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";
import { CableTypeEnum, ShieldTypeEnum, DispPrefEnum } from "./wiremapenum";
import STWiremapDiagram from "../common/stdiagram";

import NoData from "../../nodata";

class WireMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wireMap: this.props.wireMap,
      cableList: {},
      displayprefid: "",
      cabletypeid: "",
      usecustomnvp: null,
      customnvp: "",
      shieldtypeid: "",
      detectsplitpair: "",
      crossoverallowed: "",
      customcable: "",
      customcablepins: "",
      errros: {},
      searchModal: false,
      isChanged: false,
      isDetectsplitpair: true,
      formattedData: [],
      cableDetail: {},
      showConfirmBack: false,
      wiremapStandard:
        this.props.wireMap && this.props.wireMap.displayprefid != null
          ? DispPrefEnum.find(o => o.value === this.props.wireMap.displayprefid)
            .key
          : "568B",
      showRestoreConfirm: false,
      isWireMapUpdated: false,
      isShieldDisabled: false
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillMount() {
    this.props.getWireMap();
    if (this.props.isTestEdit === true) {
      this.props.getCableList(this.props.customerId);
    } else {
      this.props.getCableList(null);
    }

    this.updateCableListState(this.props.cableList);
  }
  componentWillReceiveProps(nextProps) {
    const { wireMap, cableList, isTestEdit, wiremapDetails } = nextProps;
    if (isTestEdit && !wiremapDetails) {
      if (wireMap && this.props.wireMap != wireMap) {
        this.updateWireMapState(wireMap);
        this.setState({
          cableList: cableList,
          wiremapStandard:
            wireMap && wireMap.displayprefid != null
              ? DispPrefEnum.find(o => o.value === wireMap.displayprefid).key
              : "568B"
        });
        this.updateCableListState(cableList);
      }
    } else if (isTestEdit && wiremapDetails) {
      if (
        (wiremapDetails && this.props.wiremapDetails != wiremapDetails) ||
        !this.state.isWireMapUpdated
      ) {
        this.updateWireMapState(wiremapDetails);
        this.setState({ isWireMapUpdated: true });
      }
    } else {
      if (wireMap && this.props.wireMap != wireMap) {
        this.updateWireMapState(wireMap);
        this.setState({
          cableList: cableList,
          wiremapStandard:
            wireMap && wireMap.displayprefid != null
              ? DispPrefEnum.find(o => o.value === wireMap.displayprefid).key
              : "568B"
        });
        this.updateCableListState(cableList);
      }
    }
  }
  updateWireMapState = wireMap => {
    let cableDetail = this.formatData([
      {
        name: wireMap.customcable,
        pin1connected: wireMap.customcablepin1,
        pin2connected: wireMap.customcablepin2,
        pin3connected: wireMap.customcablepin3,
        pin4connected: wireMap.customcablepin4,
        pin5connected: wireMap.customcablepin5,
        pin6connected: wireMap.customcablepin6,
        pin7connected: wireMap.customcablepin7,
        pin8connected: wireMap.customcablepin8,
        shield: wireMap.customcableshield
      }
    ]);
    this.setState({
      wireMap,
      cableDetail: cableDetail[0],
      displayprefid: wireMap.displayprefid,
      cabletypeid: wireMap.cabletypeid,
      usecustomnvp: wireMap.usecustomnvp,
      customnvp: wireMap.customnvp,
      shieldtypeid: wireMap.cabletypeid == 17 ? 2 : wireMap.shieldtypeid,
      detectsplitpair: wireMap.detectsplitpair,
      crossoverallowed: wireMap.crossoverallowed,
      customcable: wireMap.customcable,
      wiremapStandard:
        wireMap && wireMap.displayprefid != null
          ? DispPrefEnum.find(o => o.value === wireMap.displayprefid).key
          : "568B",
      isShieldDisabled: wireMap.cabletypeid == 17 ? true : false
    });
  };

  updateCableListState = cableList => {
    let formattedData;

    if (cableList) {
      formattedData = this.formatData(cableList);
    }
    this.setState({
      cableList,
      formattedData
    });
  };

  formatData = cableList => {
    let formattedData = [];
    for (let item in cableList) {
      let cable = cableList[item];
      let arr = [];
      for (let i = 0; i < 9; i++) {
        arr.push({
          DHPin: (i + 1).toString(),
          IsCross: false,
          IsOpen: cable["pin" + (i + 1).toString() + "connected"]
            ? false
            : true,
          IsReverse: false,
          IsShort: false,
          IsSplit: false,
          IsThru: cable["pin" + (i + 1).toString() + "connected"]
            ? true
            : false,
          IsUndefined: false
        });
      }
      if (cable.shield == true) {
        arr[8].IsThru = true;
        arr[8].IsOpen = false;
      } else {
        arr[8].IsThru = false;
        arr[8].IsOpen = true;
      }
      formattedData.push({ RefLength: 24.1, Details: arr, ...cableList[item] });
    }
    // this.setState({
    //   formattedData
    // });
    return formattedData;
  };

  onCableSelectOpen = () => {
    this.setState({
      searchModal: true,
      isChanged: true,
      isRestore: false
    });
  };

  onCableSelectClose = () => {
    this.setState({
      searchModal: false,
      isChanged: false
    });
  };

  onCableSearchSelect = cableDetail => {
    this.setState({
      searchModal: false,
      cableDetail
    });
  };

  onCableRemove = () => {
    this.setState({
      cableDetail: {},
      isChanged: true,
      isRestore: false
    });
  };

  onChange = e => {
    // let selectedTrResult = { ...this.state.selectedTrResult };
    // selectedTrResult["namelookup"] = e.target.checked;
    if (
      e.target.name == "usecustomnvp" ||
      e.target.name == "detectsplitpair" ||
      e.target.name == "crossoverallowed"
    ) {
      this.setState({
        [e.target.name]: e.target.checked,
        isChanged: true,
        isRestore: false
      });
    } else if (e.target.name == "shieldtypeid") {
      let errors = { ...this.state.errors };
      errors = {
        ...errors,
        [e.target.name]: false
      };
      this.setState({
        [e.target.name]: e.target.value,
        isChanged: true,
        isRestore: false,
        errors
      });
    } else if (e.target.name == "cabletypeid") {
      let errors = { ...this.state.errors };
      errors = {
        ...errors,
        [e.target.name]: false
      };
      this.setState({
        [e.target.name]: e.target.value,
        isChanged: true,
        isRestore: false,
        cableDetail: {},
        errors,
        shieldtypeid: e.target.value == 17 ? 2 : this.state.shieldtypeid,
        isShieldDisabled: e.target.value == 17 ? true : false
      });
    } else if (e.target.name == "displayprefid") {
      let errors = { ...this.state.errors };
      errors = {
        ...errors,
        [e.target.name]: false
      };
      this.setState({
        [e.target.name]: e.target.value,
        wiremapStandard: DispPrefEnum.find(o => o.value === e.target.value).key,
        isChanged: true,
        isRestore: false,
        errors
      });
    } else if (e.target.name == "customnvp") {
      let errors = { ...this.state.errors };
      errors = {
        ...errors,
        [e.target.name]: false
      };
      this.setState({
        [e.target.name]:
          e.target.value == 0
            ? e.target.value
            : Number(e.target.value)
              ? Number(e.target.value)
              : "",
        isChanged: true,
        isRestore: false,
        errors
      });
    }

    //else if (e.target.name == "shieldtypeid") {
    //    this.setState({ shieldtypeid: e.target.value, isChanged: true });
    //  } else if (e.target.name == "displayprefid") {
    //    this.setState({ displayprefid: e.target.value, isChanged: true });
    //  } else if (e.target.name == "customnvp") {
    //    this.setState({ customnvp: e.target.value, isChanged: true });
    //  }
  };

  handleSubmit = () => {
    let { translate, isTestEdit } = this.props;
    const {
      displayprefid,
      cabletypeid,
      usecustomnvp,
      customnvp,
      shieldtypeid,
      detectsplitpair,
      crossoverallowed,
      cableDetail,
      isRestore
    } = this.state;
    let updatedWireMap = {
      displayprefid: displayprefid,
      cabletypeid: cabletypeid,
      usecustomnvp: usecustomnvp,
      customnvp: customnvp,
      shieldtypeid: shieldtypeid,
      detectsplitpair: detectsplitpair,
      crossoverallowed: crossoverallowed,
      customcable: cableDetail.name,
      customcablepin1: cableDetail.pin1connected,
      customcablepin2: cableDetail.pin2connected,
      customcablepin3: cableDetail.pin3connected,
      customcablepin4: cableDetail.pin4connected,
      customcablepin5: cableDetail.pin5connected,
      customcablepin6: cableDetail.pin6connected,
      customcablepin7: cableDetail.pin7connected,
      customcablepin8: cableDetail.pin8connected,
      customcableshield: cableDetail.shield
    };

    let vObj = {
      customnvp: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 58,
          maxValue: 89,
          message: translate("sub_test_ping_validation_range", {
            name: "Custom NVP%",
            value1: 58,
            value2: 89
          })
        },
        type: {
          value: "numeric",
          message: translate("subtest_numeric_validation", {
            name: translate("general_sub_test_wiremap_nvp_per_label")
          })
        }
      }
    };
    let errors = validateFormData(updatedWireMap, vObj);
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors, ischanged: false });
    } else {
      let self = this;

      this.setState({
        isChanged: false
      });
      if (isTestEdit) {
        this.props.updateWireMap(this.props.selectedTest, updatedWireMap);
        this.props.handleClose();
      } else {
        this.props.updateWireMap(updatedWireMap);
      }
      if (isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
    }
  };
  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };
  onRestoreConfirm = () => {
    //this.props.updateUpTime(this.props.selectedTest, this.props.upTime);
    this.updateWireMapState(this.props.wireMap);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };
  onBackYesClick = () => {
    this.handleSubmit();
    this.setState({
      showConfirmBack: false
    });
  };
  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  render() {
    const { translate, classes, isTestEdit, wiremapDetails, testEdit, modified } = this.props;
    const {
      wireMap,
      displayprefid,
      cabletypeid,
      usecustomnvp,
      customnvp,
      shieldtypeid,
      detectsplitpair,
      crossoverallowed,
      customcable,
      customcablepins,
      errors,
      searchModal,
      isChanged,
      cableList,
      formattedData,
      cableDetail,
      wiremapStandard,
      isRestore,
      isShieldDisabled
    } = this.state;

    let $modal = null;
    if (searchModal) {
      $modal = (
        <SelectCable
          formattedData={formattedData}
          //languages={languages}
          modal={searchModal}
          onClose={this.onCableSelectClose}
          // onCableAddSubmit={this.onCableAddSubmit}
          wiremapStandard={wiremapStandard}
          selectCable={this.onCableSearchSelect}
          translate={translate}
          isTestEdit={isTestEdit}
        />
      );
    }

    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("general_sub_test_wiremap_head")}
          />
        )}
        <Content translate={translate}>
          {wireMap && (usecustomnvp === true || usecustomnvp === false) && (
            <Grid container spacing={1}>
              <Grid item xs={!isTestEdit ? 4 : 0}></Grid>
              <Grid item xs={!isTestEdit ? 4 : 8}>
                <Grid item xs={4} sm={12}>
                  <TextField
                    select
                    name={"cabletypeid"}
                    value={
                      cabletypeid && cabletypeid.length
                        ? cabletypeid[0].value
                        : cabletypeid
                    }
                    label={translate(
                      "general_sub_test_wiremap_cable_type_label"
                    )}
                    onChange={this.onChange}
                    error={false}
                    margin="normal"
                    //disabled={certainty == 0}
                    fullWidth
                  >
                    {CableTypeEnum.map(item => {
                      return (
                        <MenuItem key={item.key} value={item.value}>
                          {item.key}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={4} sm={12}>
                  <TextField
                    select
                    name={"shieldtypeid"}
                    value={
                      shieldtypeid && shieldtypeid.length
                        ? shieldtypeid[0].value
                        : shieldtypeid
                    }
                    label={translate(
                      "general_sub_test_wiremap_shield_type_label"
                    )}
                    onChange={this.onChange}
                    error={false}
                    margin="normal"
                    disabled={isShieldDisabled}
                    fullWidth
                  >
                    {ShieldTypeEnum.map(item => {
                      return (
                        <MenuItem key={item.key} value={item.value}>
                          {item.key}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={4} sm={12}>
                  <TextField
                    select
                    name={"displayprefid"}
                    value={
                      displayprefid && displayprefid.length
                        ? displayprefid[0].value
                        : displayprefid
                    }
                    label={translate(
                      "general_sub_test_wiremap_disp_pref_label"
                    )}
                    onChange={this.onChange}
                    error={false}
                    margin="normal"
                    //disabled={certainty == 0}
                    fullWidth
                  >
                    {DispPrefEnum.map(item => {
                      return (
                        <MenuItem key={item.key} value={item.value}>
                          {item.key}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={4} sm={12}>
                  <FormControlLabel
                    //className={classes.textFieldL}
                    control={
                      <Checkbox
                        name="usecustomnvp"
                        checked={usecustomnvp}
                        onChange={this.onChange}
                        value={usecustomnvp}
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={classes.lookup}>
                        {translate("general_sub_test_wiremap_nvp_per_label")}
                      </Typography>
                    }
                  />
                </Grid>
                <Grid item xs={4} sm={12}>
                  <TextField
                    className={classes.textField}
                    error={errors && errors.customnvp ? true : false}
                    name="customnvp"
                    margin="normal"
                    value={customnvp}
                    helperText={
                      errors && errors.customnvp ? errors.customnvp : ""
                    }
                    disabled={!usecustomnvp}
                    onChange={this.onChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4} sm={12}>
                  {[7, 9, 10, 13, 14].indexOf(cabletypeid) >= 0 ? null : (
                    <FormControlLabel
                      //className={classes.textFieldL}
                      control={
                        <Checkbox
                          name="detectsplitpair"
                          checked={detectsplitpair}
                          onChange={this.onChange}
                          value={detectsplitpair}
                          color="primary"
                        />
                      }
                      label={
                        <Typography className={classes.lookup}>
                          {translate(
                            "general_sub_test_wiremap_split_pair_label"
                          )}
                        </Typography>
                      }
                      fullWidth
                    />
                  )}
                </Grid>
                <Grid item xs={4} sm={12}>
                  {[7, 8, 9, 10, 13, 14, 15, 16, 17].indexOf(cabletypeid) >=
                    0 ? null : (
                      <FormControlLabel
                        //className={classes.textFieldL}
                        control={
                          <Checkbox
                            name="crossoverallowed"
                            checked={crossoverallowed}
                            onChange={this.onChange}
                            value={crossoverallowed}
                            color="primary"
                          />
                        }
                        label={
                          <Typography className={classes.lookup}>
                            {translate(
                              "general_sub_test_wiremap_cross_over_label"
                            )}
                          </Typography>
                        }
                        fullWidth
                      />
                    )}
                </Grid>
                <Grid item xs={4} sm={12}>
                  {cabletypeid == 17 ? (
                    cableDetail &&
                      cableDetail.name &&
                      cableDetail.name.length >= 0 &&
                      cableDetail.Details &&
                      cableDetail.Details.length > 0 ? (
                        <div>
                          <Typography className={classes.modelName}>
                            {"1. " + cableDetail.name}
                          </Typography>
                          <STWiremapDiagram
                            data={cableDetail}
                            translate={translate}
                            wiremapStandard={wiremapStandard}
                            isEdit="false"
                            isAdd="false"
                          />
                          <Button
                            color="primary"
                            onClick={() => this.onCableRemove()}
                            disabled={cabletypeid != 17}
                          >
                            <Icon> remove </Icon>
                            {translate("general_sub_test_wiremap_rem_cust_cable")}
                          </Button>
                        </div>
                      ) : (
                        <Button
                          color="primary"
                          onClick={() => this.onCableSelectOpen()}
                          disabled={cabletypeid != 17}
                        >
                          <Icon> add </Icon>
                          {translate("general_sub_test_wiremap_add_cust_cable")}
                        </Button>
                      )
                  ) : null}
                </Grid>
                <Grid item xs={4} sm={12}>
                  {!isTestEdit && (
                    <Button
                      raised
                      color="primary"
                      className={classes.submit}
                      onClick={this.handleSubmit}
                      type="submit"
                      disabled={!isChanged}
                    >
                      {translate("sub_set_ping_save_target")}
                    </Button>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          )}
          {$modal}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: "Wiremap"
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={testEdit ? translate("test_edit_title") : translate("test_add")}
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={testEdit ? translate("test_edit_title") : translate("test_add")}
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit &&
          wireMap &&
          (usecustomnvp === true || usecustomnvp === false) && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <div style={{ display: "inline-block", marginLeft: "20px" }}>
                {wiremapDetails && !testEdit ? (
                  <Button
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : testEdit && modified ? (
                  <Button
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : null}
              </div>
              <div style={{ display: "inline-block", marginRight: "20px" }}>
                <Button
                  disabled={!isChanged}
                  color="accent"
                  raised
                  onClick={() => this.handleSubmit()}
                  className={classes.saveTarget}
                >
                  {translate("general_continue")}
                </Button>
              </div>
            </div>
          )}
      </div>
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}
export default withRouter(withStyles(styles)(WireMap));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/wiremap/index.js